var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndentationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_30912",
    "data-name": "Group 30912",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 17.457,
    viewBox: "0 0 20 17.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30622",
    "data-name": "Group 30622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30621",
    "data-name": "Group 30621",
    transform: "translate(0 1.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50132",
    "data-name": "Path 50132",
    d: "M257.476,288.531h-7.943a.4.4,0,0,1-.4-.4v-3.54a.4.4,0,0,1,.4-.4h7.943a.4.4,0,0,1,.4.4v3.54A.4.4,0,0,1,257.476,288.531Zm-7.539-.807h7.135v-2.733h-7.135Z",
    transform: "translate(-237.879 -284.184)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50133",
    "data-name": "Path 50133",
    d: "M259.564,293.494h-19.2a.4.4,0,0,1-.4-.4v-3.54a.4.4,0,0,1,.4-.4h19.2a.4.4,0,0,1,.4.4v3.54A.4.4,0,0,1,259.564,293.494Zm-18.8-.807h18.4v-2.733h-18.4Z",
    transform: "translate(-239.963 -283.207)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50134",
    "data-name": "Path 50134",
    d: "M259.564,298.457h-19.2a.4.4,0,0,1-.4-.4v-3.54a.4.4,0,0,1,.4-.4h19.2a.4.4,0,0,1,.4.4v3.54A.4.4,0,0,1,259.564,298.457Zm-18.8-.808h18.4v-2.732h-18.4Z",
    transform: "translate(-239.963 -282.23)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50135",
    "data-name": "Path 50135",
    d: "M246.748,290.005a.916.916,0,0,1-.912-.912v-.912h-5.469a.4.4,0,1,1,0-.808h5.873a.4.4,0,0,1,.4.4v1.316a.1.1,0,0,0,.176.072l2.493-2.492a.1.1,0,0,0,0-.146l-2.493-2.493a.1.1,0,0,0-.112-.022.1.1,0,0,0-.064.1v1.316a.4.4,0,0,1-.4.4h-5.873a.4.4,0,1,1,0-.807h5.469v-.912a.911.911,0,0,1,1.555-.645l2.492,2.493a.911.911,0,0,1,0,1.288l-2.492,2.492A.909.909,0,0,1,246.748,290.005Z",
    transform: "translate(-239.963 -283.198)",
    fill: "#333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndentationIcon);
export default __webpack_public_path__ + "static/media/indentationIcon.6fc859e0.svg";
export { ForwardRef as ReactComponent };